import { DisplayWord } from "@circleofa/acim-engine"
import { CopyWord } from "@utils/reading/copy"
import { derived, writable } from "svelte/store"
import Worker from "./worker/image-quote-generate-promise.worker?worker"
import { type GetFinalImagesPromise } from "./worker/image-quote-worker-types"
import { htmlToAst } from "@circleofa/canvas-quotes"
import { send } from "promise-worker-ts"

const words = writable<DisplayWord[] | null>(null)
/**
 * Only allow paths from the actual text, not supplementary
 */
const ALLOWED_PATHS = ["In", "T-", "W-", "M-", "C-"]
export const isQuoteAllowed = (path: string) =>
    ALLOWED_PATHS.some((allowed) => path.startsWith(allowed))
export const unsetImageQuoteWords = () => words.set(null)
export const setImageQuoteWords = (dwords: DisplayWord[]) => {
    // Only real text should be allowed
    const path = dwords[0].actualParent.path
    if (isQuoteAllowed(path)) {
        words.set(dwords)
    } else {
        throw new Error(`Quote path not allowed: ${path}`)
    }
}
/**
 * null if not set
 */
export const imageQuote = derived(words, ($words) => ($words ? new ImageQuote($words) : null))

/**
 * Whether we are allowed to do image quotes or not
 */
export const IMAGE_QUOTE_ALLOWED = "OffscreenCanvas" in globalThis

export class ImageQuote {
    constructor(public readonly words: DisplayWord[]) {
        this.copyWords = new CopyWord(this.words)
    }
    copyWords: CopyWord
}

export const getQuoteImages = async (html: string, path: string) => {
    const worker = getImageQuoteWorker()
    const images = await send<GetFinalImagesPromise>("draw", worker, {
        htmlAst: htmlToAst(html, document),
        path,
    })
    return images
}

let worker: Worker | null = null
function getImageQuoteWorker() {
    if (!worker) {
        worker = new Worker()
    }
    return worker
}
